// @flow
import React from 'react'
import styled from 'styled-components'
import type { Booking as BookingType } from 'src/types'
import Modal, { Align } from './Modal'
import { StyledButton } from './StyledElements'
import { Title } from 'src/theme/globalStyle'
import { BookingInfo } from 'src/components/BookingInfo'
import { media } from 'src/theme/style-utils'

type Props = {
  open: boolean,
  toClose: Function,
  booking: BookingType,
  bookingDeposit: string,
  adminFee: string,
  paymentPlan: string,
  roomType: string
}

const BookingModal = (props: Props) => {
  const { booking, paymentPlan, bookingDeposit, adminFee, toClose } = props
  // should return modal Content and modal
  return (
    props.open && (
      <Modal {...props} align={Align.top}>
        <BookingModal.Wrapper
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          <BookingModal.Header>
            <Title noMargin style={{ alignSelf: 'flex-end' }}>
              {props.roomType}
            </Title>
            <StyledButton onClick={toClose}>Hide</StyledButton>
          </BookingModal.Header>
          <BookingInfo
            booking={booking}
            paymentPlan={paymentPlan || 'monthly'}
            bookingDeposit={bookingDeposit}
            adminFee={adminFee}
            modalLayout={true}
          />
        </BookingModal.Wrapper>
      </Modal>
    )
  )
}

BookingModal.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  ${media.tabletLarge`
    padding: 20px 40px;
  `}
  & * {
    box-sizing: border-box;
  }
`

BookingModal.Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`

export default BookingModal



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/MobileHeader/BookingModal.js